import { get } from 'lodash';

export function formatNewsDuration(runtime){
    let res = '';
    let mins = ~~(runtime / 60);

    if(mins === 0){
        res = `${runtime} SEC`
    } else {
        res = `${mins} MIN`
    }

    return res;
}

export function getHignResImage(props) {
    var gist = props.item.gist;
    var url =
      props.thumbnailType === "portrait"
        ? gist.posterImageUrl ||
          get(gist.posterImage, "url") ||
          get(props.item.images, "_3x4Image.secureUrl") ||
          get(props.item.gist, 'imageGist["_3x4"]') ||
          get(window.settings, "images.placeholderPoster")
        : gist.videoImageUrl ||
          get(gist.videoImage, "url") ||
          get(gist, "landscapeImageUrl") ||
          get(props.item.images, "_16x9Image.secureUrl") ||
          get(props.item.gist, 'imageGist["_16x9"]') ||
          get(props.item.images, "_16x9.url") ||
          get(window.settings, "images.placeholderCover");
    return url;
  }